import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const selectSectionFn = /* @__PURE__ */ createRecipe('select-section', {}, [])

const selectSectionVariantMap = {}

const selectSectionVariantKeys = Object.keys(selectSectionVariantMap)

export const selectSection = /* @__PURE__ */ Object.assign(memo(selectSectionFn.recipeFn), {
  __recipe__: true,
  __name__: 'selectSection',
  __getCompoundVariantCss__: selectSectionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: selectSectionVariantKeys,
  variantMap: selectSectionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, selectSectionVariantKeys)
  },
  getVariantProps: selectSectionFn.getVariantProps,
})